import orderBy from 'lodash/orderBy';

export const partners = ({ items }) => orderBy(items, ['id'], ['desc'])
